import { render, staticRenderFns } from "./CustomScript.vue?vue&type=template&id=62c36c40&"
import script from "./CustomScript.vue?vue&type=script&lang=js&"
export * from "./CustomScript.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports